module.exports = __webpack_public_path__ + "img/service2.e0929e56.png";